import { useContext } from 'react';
import { AppContext, AppContextType } from '../AppContext';

export interface TasksSortingOptionType extends Pick<AppContextType, 'sortTasksBy' | 'setSortTasksBy'> {}

export function useTasksSortingOption(): TasksSortingOptionType {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useTasksSortingOption must be used within a AppContextProvider');
  }
  const { sortTasksBy, setSortTasksBy } = context;

  return {
    sortTasksBy,
    setSortTasksBy,
  };
}
